import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelDvorak: KeyLabel[] = [
  {
    code: 4,
    label: 'A',
  },
  {
    code: 5,
    label: 'X',
  },
  {
    code: 6,
    label: 'J',
  },
  {
    code: 7,
    label: 'E',
  },
  {
    code: 8,
    label: '.',
    meta: [
      {
        label: '>',
        modifiers: MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 9,
    label: 'U',
  },
  {
    code: 10,
    label: 'I',
  },
  {
    code: 11,
    label: 'D',
  },
  {
    code: 12,
    label: 'C',
  },
  {
    code: 13,
    label: 'H',
  },
  {
    code: 14,
    label: 'T',
  },
  {
    code: 15,
    label: 'N',
  },
  {
    code: 16,
    label: 'M',
  },
  {
    code: 17,
    label: 'B',
  },
  {
    code: 18,
    label: 'R',
  },
  {
    code: 19,
    label: 'L',
  },
  {
    code: 20,
    label: "'",
    meta: [
      {
        label: '"',
        modifiers: MOD.SFT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 21,
    label: 'P',
  },
  {
    code: 22,
    label: 'O',
  },
  {
    code: 23,
    label: 'Y',
  },
  {
    code: 24,
    label: 'G',
  },
  {
    code: 25,
    label: 'K',
  },
  {
    code: 26,
    label: ',',
    meta: [
      {
        label: '<',
        modifiers: MOD.SFT,
      },
      {
        label: '<',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 27,
    label: 'Q',
  },
  {
    code: 28,
    label: 'F',
  },
  {
    code: 29,
    label: ';',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 30,
    label: '1',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 31,
    label: '2',
    meta: [
      {
        label: '@',
        modifiers: MOD.SFT,
      },
      {
        label: '@',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 32,
    label: '3',
    meta: [
      {
        label: '#',
        modifiers: MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 33,
    label: '4',
    meta: [
      {
        label: '$',
        modifiers: MOD.SFT,
      },
      {
        label: '$',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 34,
    label: '5',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 35,
    label: '6',
    meta: [
      {
        label: '^',
        modifiers: MOD.SFT,
      },
      {
        label: '^',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 36,
    label: '7',
    meta: [
      {
        label: '&',
        modifiers: MOD.SFT,
      },
      {
        label: '&',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 37,
    label: '8',
    meta: [
      {
        label: '*',
        modifiers: MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 38,
    label: '9',
    meta: [
      {
        label: '(',
        modifiers: MOD.SFT,
      },
      {
        label: '(',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 39,
    label: '0',
    meta: [
      {
        label: ')',
        modifiers: MOD.SFT,
      },
      {
        label: ')',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 45,
    label: '[',
    meta: [
      {
        label: '{',
        modifiers: MOD.SFT,
      },
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 46,
    label: ']',
    meta: [
      {
        label: '}',
        modifiers: MOD.SFT,
      },
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 47,
    label: '/',
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 48,
    label: '=',
    meta: [
      {
        label: '+',
        modifiers: MOD.SFT,
      },
      {
        label: '+',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 49,
    label: '(backslash)',
    meta: [
      {
        label: '|',
        modifiers: MOD.SFT,
      },
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 51,
    label: 'S',
  },
  {
    code: 52,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 53,
    label: '`',
    meta: [
      {
        label: '~',
        modifiers: MOD.SFT,
      },
      {
        label: '~',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 54,
    label: 'W',
  },
  {
    code: 55,
    label: 'V',
  },
  {
    code: 56,
    label: 'Z',
  },
  {
    code: 520,
    label: '>',
  },
  {
    code: 532,
    label: '"',
  },
  {
    code: 538,
    label: '<',
  },
  {
    code: 541,
    label: ':',
  },
  {
    code: 542,
    label: '!',
  },
  {
    code: 543,
    label: '@',
  },
  {
    code: 544,
    label: '#',
  },
  {
    code: 545,
    label: '$',
  },
  {
    code: 546,
    label: '%',
  },
  {
    code: 547,
    label: '^',
  },
  {
    code: 548,
    label: '&',
  },
  {
    code: 549,
    label: '*',
  },
  {
    code: 550,
    label: '(',
  },
  {
    code: 551,
    label: ')',
  },
  {
    code: 557,
    label: '{',
  },
  {
    code: 558,
    label: '}',
  },
  {
    code: 559,
    label: '?',
  },
  {
    code: 560,
    label: '+',
  },
  {
    code: 561,
    label: '|',
  },
  {
    code: 564,
    label: '_',
  },
  {
    code: 565,
    label: '~',
  },
  {
    code: 4616,
    label: '>',
  },
  {
    code: 4628,
    label: '"',
  },
  {
    code: 4634,
    label: '<',
  },
  {
    code: 4637,
    label: ':',
  },
  {
    code: 4638,
    label: '!',
  },
  {
    code: 4639,
    label: '@',
  },
  {
    code: 4640,
    label: '#',
  },
  {
    code: 4641,
    label: '$',
  },
  {
    code: 4642,
    label: '%',
  },
  {
    code: 4643,
    label: '^',
  },
  {
    code: 4644,
    label: '&',
  },
  {
    code: 4645,
    label: '*',
  },
  {
    code: 4646,
    label: '(',
  },
  {
    code: 4647,
    label: ')',
  },
  {
    code: 4653,
    label: '{',
  },
  {
    code: 4654,
    label: '}',
  },
  {
    code: 4655,
    label: '?',
  },
  {
    code: 4656,
    label: '+',
  },
  {
    code: 4657,
    label: '|',
  },
  {
    code: 4660,
    label: '_',
  },
  {
    code: 4661,
    label: '~',
  },
];
